<script>
import clientApiDrive from "@/services/http/api-drive/client";
import MdpOublieConfirmation from "@/components/organisms/connexion/mdp-oublie-confirmation";
import { states } from "@/components/molecules/mixins/form.mixin";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  components: {
    MdpOublieConfirmation,
    StateOverlay
  },  
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      state: null,
      error: null
    };
  },
  computed: {
    isLoading() {
      return this.state === states.LOADING;
    }
  },
  methods: {
    async resetPassword(data) {
      this.state = states.LOADING;
      try {
        await this.$apiDrive
          .use(clientApiDrive)
          .resetPassword(this.email, data.captcha);
        this.state = states.SUCCESS;
      } catch (error) {
        this.state = states.ERROR;
        this.error = this.$apiDrive.getErrorData(error);
      }
    }
  }
};
</script>

<template>
  <StateOverlay
    :is-loading="isLoading"
    message="Envoi de votre demande en cours..."
  >
    <MdpOublieConfirmation
      :state="state"
      :error="error"
      :email="email"
      @resetPassword="resetPassword"
    />
  </StateOverlay>
</template>
